import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.684.051a1 1 0 0 1 .632 0l8.998 3a1 1 0 0 1 .684.948l-1 .001h1v2.25L22 13c0 3.497-2.596 6.258-4.886 8.04a25.474 25.474 0 0 1-4.674 2.858l-.023.011-.007.003-.003.001L12 23c-.406.914-.406.914-.407.913h-.003l-.007-.004-.023-.01a11.211 11.211 0 0 1-.388-.185 25.468 25.468 0 0 1-4.286-2.674C4.596 19.257 2 16.496 2 13l.001-6.75L2.002 4a1 1 0 0 1 .684-.949l8.998-3Zm-7.682 4.67v1.53L4 13c0 2.503 1.905 4.742 4.114 6.46A23.48 23.48 0 0 0 12 21.893a23.462 23.462 0 0 0 3.886-2.431C18.096 17.742 20 15.503 20 13l-.001-6.75V4.72l-8-2.666-7.997 2.667ZM12 23l-.407.913c.259.116.555.116.813 0L12 23Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
